import React, { useContext } from "react";
import { SelectButton } from "../../components/Buttons";
import cs from "classnames";
import { FormGroup } from "../../components/FormGroup";
import {
  ChoiceLayout,
  ChoiceTypes,
  PageQuestion,
} from "../../types/hexpertTypes";
import { HexpertContext } from "../../contexts/HexPertProvider";
import {
  unitConverter,
  unitConvertName,
  UnitTypes,
} from "../../helpers/unitsConversion";
import './HexpertTemperatureChoiceBlock.scss';

export const HexpertTemperatureChoiceBlock = (props: PageQuestion) => {
  const { Label, Options, CheckboxType, CheckboxOrientation, FieldId } = props;
  const { state, dispatch } = useContext(HexpertContext);

  return (
    <FormGroup title={Label}>
      <div
        className={cs("c-hex-choice-block-container", {
          "c-hex-choice-block-container--column":
            CheckboxOrientation === ChoiceLayout.VERTICAL,
          "c-hex-choice-block-container--nowrap":
            CheckboxType === ChoiceTypes.LARGE_BUTTON,
        })}
      >
        {Options?.map((item) => (
          <SelectButton
            {...item}
            key={item.Value}
            label={
              item.Caption.split("-")
                .map((unit) =>
                  Math.round(
                    unitConverter(UnitTypes.TEMPERATURE, state.unitSystem, unit)
                  )
                )
                .join(" - ") +
              ` ${unitConvertName(UnitTypes.TEMPERATURE, state.unitSystem)}`
            }
            name={Label}
            action={() => {
              dispatch({
                type: "setAnswer",
                payload: { [FieldId]: item.Value },
              });
            }}
            selected={
              state?.formAnswers &&
              state?.formAnswers?.[FieldId] === item?.Value
            }
          />
        ))}
      </div>
    </FormGroup>
  );
};
